import { Identifiable } from "./identifiable";
import { Tag } from "./tag";

type Tagged<Type> = Type & {
  tags: Identifiable<Tag>[];
};

export type { Tagged };
